import React, { useEffect, useState } from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import "./hkpDrawer.scss";

type Props = {
  open: boolean;
  mode: "view" | "create" | "edit";
  title: string;
  busy?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** On phones, open as a bottom sheet (about 80% of the screen) instead of a full-width side panel. */
  sheetOnMobile?: boolean;
};

const useIsPhone = (enabled: boolean) => {
  const query = "(max-width: 767px)";
  const [phone, setPhone] = useState(() => enabled && typeof window !== "undefined" && !!window.matchMedia?.(query).matches);
  useEffect(() => {
    if (!enabled || typeof window === "undefined" || !window.matchMedia) return;
    const list = window.matchMedia(query);
    const sync = () => setPhone(list.matches);
    sync();
    list.addEventListener?.("change", sync);
    return () => list.removeEventListener?.("change", sync);
  }, [enabled]);
  return enabled && phone;
};

/** Contextual View/Create/Edit shell with a scrollable body and reachable actions. */
const HKPDrawer = ({ open, mode, title, busy = false, onClose, children, footer, sheetOnMobile = false }: Props) => {
  const sheet = useIsPhone(sheetOnMobile);
  return (
  <Offcanvas isOpen={open} toggle={busy ? undefined : onClose} direction={sheet ? "bottom" : "end"} className={sheet ? "hkp-drawer hkp-drawer--sheet" : "hkp-drawer"} backdropClassName="hkp-drawer-backdrop" labelledBy="hkp-drawer-title">
    <OffcanvasHeader toggle={busy ? undefined : onClose}>
      <span id="hkp-drawer-title">{title}</span>
    </OffcanvasHeader>
    <OffcanvasBody className="hkp-drawer__content" data-mode={mode}>
      <div className="hkp-drawer__body">{children}</div>
      {footer && <div className="hkp-drawer__footer">{footer}</div>}
    </OffcanvasBody>
  </Offcanvas>
  );
};

export default HKPDrawer;
